<template>
  <div class="bubbles-background">
    <div class="layer layer-1" />
    <div class="layer layer-2" />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="sass" scoped>
  @import '~@/stylesheets/base/variables'

  @keyframes fade
    0%,100%
      opacity: 0
    50%
      opacity: 0.50

  @keyframes zoom
    0%,100%
      transform: scale(1.1) rotate(10deg)
    50%
      transform: scale(2) rotate(-10deg)

  @keyframes flipped-zoom
    0%,100%
      transform: scale(-1.1) rotate(35deg)
    50%
      transform: scale(-1.8) rotate(-35deg)

  $fade-duration: 60s
  $fade-offset: $fade-duration / 2 * -1
  $zoom-duration: 228s
  $zoom-offset: $zoom-duration / 2 * -1

  .bubbles-background
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    z-index: 9999
    pointer-events: none
    overflow: hidden

    .coral
      position: absolute
      bottom: 0

    .layer
      position: absolute
      width: 100%
      height: 100%
      opacity: 0
      animation-name: fade, zoom
      animation-duration: $fade-duration, $zoom-duration
      animation-timing-function: linear
      animation-iteration-count: infinite
      background-repeat: repeat
      background-image: url('~@/assets/images/dots.svg')

      &.layer-2
        animation-name: fade, flipped-zoom
        animation-delay: $fade-offset, $zoom-offset
        background-position: right 5% bottom 0
</style>
